module.exports = __webpack_public_path__ + "img/desktop.2f979c92.jpg";